import { PAGE_SIZE } from '../../../constants/Config';
import {
    TIME_SHIFT_DELETE,
    TIME_SHIFT_DETAIL,
    TIME_SHIFT_INSERT,
    TIME_SHIFT_LIST,
    TIME_SHIFT_UPDATE,
    TIME_SHIFT_GET_ALL
} from './action-types';

const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    item: null
};

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case TIME_SHIFT_LIST:
            return list(state, payload);
        case TIME_SHIFT_DETAIL:
            return detail(state, payload);
        case TIME_SHIFT_UPDATE:
            return update(state, payload);
        case TIME_SHIFT_INSERT:
            return insert(state, payload);
        case TIME_SHIFT_DELETE:
            return deletes(state, payload);
        case TIME_SHIFT_GET_ALL:
            return getAll(state, payload);
        default:
            return state;
    }
};

function list(state, payload) {
    return { ...state, ...payload };
}

function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload
    });
    return state;
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.UserId !== payload);

    return Object.assign({}, state, { data });
}

function update(state, payload) {
    const data = state.data.map(obj => {
        if (obj.UserId === payload.UserId) {
            return { ...obj, ...payload };
        }
        return obj;
    });

    return Object.assign({}, state, { data });
}

function insert(state, payload) {
    const data = [...state.data, payload];
    return Object.assign({}, state, { data });
}

function getAll(state, payload) {
    state = Object.assign({}, state, { data: payload });
    return state;
}

export const getTimeShiftsList = state => state.coreTimeShift.data;

export default reducer;
